module.exports = __webpack_public_path__ + "static/img/1000av-post2.dee45d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1000av-post2.png
// module id = /nin
// module chunks = 1